import React, { useEffect } from 'react';
import { Navigate, useLocation, useNavigate, useParams } from 'react-router-dom';
import { Skeleton, styled, Typography } from '@mui/material';

import { publicRoutes } from '../../../routes/appRouteList';
import { useAppDispatch, useAppSelector } from '../../../state/hooks';
import { clearAreaDetailsData } from '../../../state/features/areaDetailsSlice';
import { ApiStatus } from '../../../utils/enums';
import DetailHeader from './DetailHeader';

const classesPrefix = 'areaDetailsHeader';

const classes = {
    loading: `${classesPrefix}-loading`,
};

const StyledSkeleton = styled(Skeleton)(({ theme }) => {
    return {
        [`&.${classes.loading}`]: {
            backgroundColor: theme.palette.grey[100],
        },
    };
});

const AreaDetailsHeader = (): React.JSX.Element => {
    const dispatch = useAppDispatch();
    const navigate = useNavigate();
    const location = useLocation();
    const params = useParams<{ name: string; }>();

    const detailsApiStatus = useAppSelector((state) => { return state.area.detailsApiStatus; });
    const details = useAppSelector((state) => { return state.area.details; });

    useEffect(() => {
        return () => {
            dispatch(clearAreaDetailsData());
        };
    }, [dispatch]);

    if (detailsApiStatus === ApiStatus.Failure) {
        return (
            <Navigate
                to={`${publicRoutes.notFound}?requestedroute=${encodeURIComponent(`${location.pathname}${location.search}`)}&reason=${encodeURIComponent(`We tried, but we couldn't find an area named ${params.name}.`)}`}
            />
        );
    }

    return (
        <DetailHeader
            onBackClicked={(): void => {
                navigate(-1);
            }}
        >
            <Typography variant='h6'>
                {
                    detailsApiStatus === ApiStatus.Loading ?
                        <StyledSkeleton className={classes.loading} width={150} />
                        :
                        details?.service_area_name || details?.service_area_id
                }
            </Typography>
        </DetailHeader>
    );
};

export default AreaDetailsHeader;
